import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Compass } from "lucide-react";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="bg-grid flex min-h-[60vh] items-center" data-testid="notfound-page">
      <div className="mx-auto max-w-lg px-4 py-24 text-center">
        <Compass className="mx-auto h-12 w-12 text-gold" />
        <h1 className="mt-4 font-display text-4xl font-bold text-marine">{t("notFound.title")}</h1>
        <p className="mt-3 text-sm text-slate-500">{t("notFound.sub")}</p>
        <Link to="/" className="btn-primary mt-6" data-testid="notfound-home-button">
          {t("form.backHome")}
        </Link>
      </div>
    </div>
  );
}
